import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 4,
        gap: 4,
    },
    containerLeft: {
        justifyContent: 'flex-start',
        // 不加 padding，让时间自然靠左
    },
    containerRight: {
        justifyContent: 'flex-end',
        // 不加 padding，让时间自然靠右
    },
    time: {
        fontSize: 11,
        color: '#999999',
    },
});
